import { render, staticRenderFns } from "./Textbox2.vue?vue&type=template&id=155589e6&scoped=true&"
import script from "./Textbox2.vue?vue&type=script&lang=js&"
export * from "./Textbox2.vue?vue&type=script&lang=js&"
import style0 from "./Textbox2.vue?vue&type=style&index=0&id=155589e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155589e6",
  null
  
)

export default component.exports